/* =========================================================
   BEAUTY ERA ROUTINE / BETTER TOGETHER
   ========================================================= */

if (!window.beautyEraRoutineLoaded) {
  window.beautyEraRoutineLoaded = true;

  document.addEventListener('click', async function (event) {
    const button = event.target.closest(
      '[data-be-add-one], [data-be-add-all]'
    );

    if (!button) return;

    const routine = button.closest('[data-be-routine]');
    if (!routine || button.disabled) return;

    const originalText =
      button.dataset.label || button.textContent.trim();

    const cart =
      document.querySelector('cart-drawer') ||
      document.querySelector('main-cart');

    button.disabled = true;

    try {
      let items = [];

      if (button.matches('[data-be-add-one]')) {
        items = [
          {
            id: Number(button.dataset.variantId),
            quantity: 1
          }
        ];
      } else {
        button.textContent =
          button.dataset.loadingLabel || 'Adding...';

        items = Array.from(
          routine.querySelectorAll(
            '[data-be-routine-item][data-variant-id]'
          )
        ).map(function (item) {
          return {
            id: Number(item.dataset.variantId),
            quantity: 1
          };
        });
      }

      const body = {
        items: items
      };

      /* Purity cart sections */
      if (
        cart &&
        typeof cart.getSectionsToRender === 'function'
      ) {
        body.sections = cart
          .getSectionsToRender()
          .map(function (section) {
            return section.id;
          });

        body.sections_url = window.location.pathname;
      }

      const addUrl =
        routine.dataset.addUrl ||
        window.routes?.cart_add_url ||
        '/cart/add';

      const response = await fetch(addUrl + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body)
      });

      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(
          data.description ||
          data.message ||
          'Unable to add items'
        );
      }

      /* Use Purity's own cart renderer */
      if (
        cart &&
        data.sections &&
        typeof cart.renderContents === 'function'
      ) {
        cart.renderContents(data);
      }

      button.textContent =
        button.dataset.addedLabel || 'Added ✓';

      /* Purity-compatible event */
      document.dispatchEvent(
        new CustomEvent('nextsky:cart:added', {
          detail: { success: true }
        })
      );

      setTimeout(function () {
        button.disabled = false;
        button.textContent = originalText;
      }, 1600);

    } catch (error) {
      console.error('Beauty Era Routine:', error);

      document.dispatchEvent(
        new CustomEvent('nextsky:cart:added', {
          detail: { success: false }
        })
      );

      button.disabled = false;
      button.textContent = originalText;
    }
  });
}


/* =========================================================
   BEAUTY ERA WHATSAPP WIDGET
   Mobile position + hide while cart drawer is open
   + move above Purity Sticky Add to Cart
   ========================================================= */

(function () {

  function addWhatsappStyles() {
    if (document.getElementById('be-wa-position-override')) return;

    const style = document.createElement('style');
    style.id = 'be-wa-position-override';

    style.textContent = `

      /* Hide the complete WhatsApp widget while cart drawer is open */
      #wa.be-wa-cart-open {
        display: none !important;
      }

      /* Mobile + Tablet positioning */
      @media (max-width: 1024px) {

        #wa.wa__widget_container {
          z-index: 20 !important;
        }

        #wa.wa__widget_container .wa__btn_popup {
          left: 16px !important;
          right: auto !important;
          bottom: calc(
            var(--be-wa-bottom, 88px) +
            env(safe-area-inset-bottom)
          ) !important;
          top: auto !important;
          transform: none !important;
          z-index: 20 !important;
        }

        /* Hide long message bubble on mobile */
        #wa.wa__widget_container .wa__btn_popup_txt {
          display: none !important;
        }

        /* WhatsApp chat window */
        #wa.wa__widget_container .wa__popup_chat_box {
          left: 16px !important;
          right: auto !important;
          bottom: calc(
            var(--be-wa-bottom, 88px) +
            68px +
            env(safe-area-inset-bottom)
          ) !important;
          top: auto !important;
          z-index: 20 !important;
        }
      }
    `;

    document.head.appendChild(style);
  }


  function elementIsVisible(element) {
    if (!element) return false;

    const style = window.getComputedStyle(element);

    if (
      style.display === 'none' ||
      style.visibility === 'hidden' ||
      parseFloat(style.opacity || '1') === 0
    ) {
      return false;
    }

    const rect = element.getBoundingClientRect();

    return (
      rect.width > 0 &&
      rect.height > 0 &&
      rect.right > 0 &&
      rect.left < window.innerWidth &&
      rect.bottom > 0 &&
      rect.top < window.innerHeight
    );
  }


  function cartDrawerIsOpen() {
    const drawer = document.querySelector('cart-drawer');

    if (!drawer) return false;

    /* Common open states */
    if (
      drawer.hasAttribute('open') ||
      drawer.getAttribute('aria-hidden') === 'false' ||
      drawer.classList.contains('open') ||
      drawer.classList.contains('active') ||
      drawer.classList.contains('show') ||
      drawer.classList.contains('is-open')
    ) {
      return true;
    }

    /*
      Check the visible drawer panel itself.
      This also works when Purity uses translate/transform
      instead of an "open" attribute.
    */
    const panel =
      drawer.querySelector('[role="dialog"]') ||
      drawer.querySelector('.drawer__inner') ||
      drawer.querySelector('.cart-drawer__inner') ||
      drawer.querySelector('.drawer-inner') ||
      drawer;

    return elementIsVisible(panel);
  }


  function syncWhatsappWithCart() {
    const whatsapp = document.getElementById('wa');

    if (!whatsapp) return;

    whatsapp.classList.toggle(
      'be-wa-cart-open',
      cartDrawerIsOpen()
    );
  }


  function syncWhatsappWithStickyCart() {
    const whatsapp = document.getElementById('wa');

    if (!whatsapp) return;

    const sticky = document.querySelector(
      'sticky-add-cart.sticky-add-cart'
    );

    /* Normal WhatsApp position */
    let bottom = 88;

    /*
      If Purity Sticky Add to Cart is visible,
      dynamically move WhatsApp above it.
    */
    if (
      sticky &&
      sticky.classList.contains('show-sticky-cart') &&
      elementIsVisible(sticky)
    ) {
      const rect = sticky.getBoundingClientRect();

      bottom = Math.max(
        88,
        Math.ceil(
          window.innerHeight - rect.top + 12
        )
      );
    }

    whatsapp.style.setProperty(
      '--be-wa-bottom',
      bottom + 'px'
    );
  }


  let syncScheduled = false;

  function scheduleSync() {
    if (syncScheduled) return;

    syncScheduled = true;

    requestAnimationFrame(function () {
      syncScheduled = false;

      syncWhatsappWithCart();
      syncWhatsappWithStickyCart();
    });
  }


  function initBeautyEraWhatsapp() {
    addWhatsappStyles();
    scheduleSync();

    /*
      Watch Purity for:
      - drawer opening
      - drawer closing
      - cart re-rendering
      - Sticky ATC appearing/disappearing
      - WhatsApp being loaded by the app
    */
    const observer = new MutationObserver(scheduleSync);

    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: [
        'class',
        'style',
        'open',
        'aria-hidden'
      ]
    });

    window.addEventListener('resize', scheduleSync);

    document.addEventListener('click', function () {
      setTimeout(scheduleSync, 50);
      setTimeout(scheduleSync, 250);
    });
  }


  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initBeautyEraWhatsapp
    );
  } else {
    initBeautyEraWhatsapp();
  }

})();